import {LazyRoute, Parse} from 'bigdatr-style';
import {TableSortState, safeLazyImport} from 'bigdatr-style';
import {TableColumn} from '~/creative/affordance/types';
import {CreativeListOrderBy} from '~/feature/filter/CreativeSortBy';
import type {QueryStringFilters} from '~/feature/filter/types';
import {CreativeDisplay} from '~/feature/filter/useCreativeListDisplayState';

const PdfReport = safeLazyImport(() => import('~/pdf/PdfReport'));
const PdfCreativeProfile = safeLazyImport(() => import('~/pdf/PdfCreativeProfile'));

export type ReportPrintConfig = {
    creativeLimit?: number;
    matrixRowLimit?: number;
    tableColumns?: TableColumn[];
};

export type CreativeProfilePrintConfig = {
    displayMode?: CreativeDisplay;
    tableColumns?: TableColumn[];
    creativeListOrderBy?: CreativeListOrderBy;
    tableSort?: TableSortState;
};

export type PdfCreativeProfileArgs = {
    filter: QueryStringFilters;
    appUrl: string;
    printConfig?: CreativeProfilePrintConfig;
};
export default {
    pdfReport: LazyRoute<{
        reportId: string;
        printConfig?: ReportPrintConfig;
    }>({
        path: '/pdf/report/:reportId',
        parse: {
            reportId: Parse.param.string((x) => x || ''),
            printConfig: Parse.query.JSON((x) => (x || {}) as ReportPrintConfig)
        },
        component: PdfReport
    }),
    pdfCreativeProfile: LazyRoute<PdfCreativeProfileArgs>({
        path: '/pdf/creativeProfile',
        parse: {
            filter: Parse.query.JSON((x) => (x || {}) as QueryStringFilters),
            appUrl: Parse.query.string((x) => x || '/'),
            printConfig: Parse.query.JSON((x) => (x || {}) as CreativeProfilePrintConfig)
        },
        component: PdfCreativeProfile
    })
};
